import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import React from 'react';
import styled from 'styled-components';

const ProjectIndicationNone = () => {
  return (
    <StyledProjectIndicationNone>
      <div className="projectIndicationNone__box">
        <CustomText fontSize={16} fontColor="#888" fontWeight={400}>
          <T>TEETH_VALIDATION_TEXT</T>
        </CustomText>
      </div>
    </StyledProjectIndicationNone>
  );
};

const StyledProjectIndicationNone = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .projectIndicationNone__box {
    padding: 14px 20px;
    background-color: white;
    border: 1px solid #e1e1e7;
    border-radius: 5px;
  }
`;

export default ProjectIndicationNone;
